import Cookies from "universal-cookie";
import { post, put } from "axios";

import { getPythonApiAsyn, postPythonApiAsyn, putPythonApiAsyn, deletePythonApiAsyn, basePYUrl } from "../../PostAPI";
import { handleAPIError, APIError } from "../../common/errorHandler";
import { API_URL } from "../../../constants/urlConstants";
import { extractData } from "../../utils";
import { generateImageUrl, getDecoratedUrl } from "../../common/urlService";
import { asyncForEach } from "../../../utils/async";
import { getAllAttachment } from "../commonService";
import { downloadBlob } from "../../utils/download";

const cookies = new Cookies();

export const fetchManageCard = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.MANAGECARDS.FETCH_MANAGECARD,
    payload,
  });
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }

    return extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchManageCardByManageCardId = async (payload) => {
  const url = API_URL.MANAGECARDS.FETCH_BY_MANAGECARD_ID.replace(
    ":id",
    payload?.id
  );
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const deleteManageCardRecord = async ({ manageCardId }) => {
  try {
    let result = await deletePythonApiAsyn(
      `${API_URL.MANAGECARDS.DELETE_MANAGECARD}/${manageCardId}`,
      cookies.get("authorization")
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

// TODO (subham)- Refactor this to make it reusable logic
const multipartDataUploadApi = (url, { files, data }, isEdit = false) => {
  const formPayload = new FormData();
  // data part of multipart data
  const json = JSON.stringify(data);
  const blobData = new Blob([json], {
    type: "application/json",
  });
  formPayload.append("data", blobData);

  // file part of multipart data
  files?.forEach((file) => {
    formPayload.append("file", file);
  });

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      authorization: cookies.get("authorization"),
    },
  };

  if (isEdit) {
    return put(basePYUrl + url, formPayload, config);
  } else {
    return post(basePYUrl + url, formPayload, config);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  // const formPayload = new FormData();
  // // data part of multipart data
  // const json = JSON.stringify(data);
  // const blobData = new Blob([json], {
  //   type: 'application/json',
  // });
  // formPayload.append('data', blobData);

  // // file part of multipart data
  // files?.forEach((file) => {
  //   formPayload.append('file', file);
  // });

  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: cookies.get("authorization"),
    },
  };

  if (isEdit) {
    return put(basePYUrl + url, data, config);
  } else {
    return post(basePYUrl + url, data, config);
  }
};
export const createManageCardRecord = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.MANAGECARDS.CREATE_MANAGECARD}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};


export const editManageCardRecord = async (payload) => {
  const url = API_URL.MANAGECARDS.EDIT_MANAGECARDS.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchManageCardAttachmentByManageCardId = async (payload) => {
  const url = API_URL.MANAGECARDS.FETCH_BY_MANAGECARD_ID.replace(
    ":id",
    payload?.itemId
  );
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const downloadAllAttachment = async (payload) => {
  await getAllAttachment(API_URL.MANAGECARDS.FETCH_MANAGECARD_FILES, payload);
};

export const exportManageCardRecord = async (payload) => {
  const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const url = API_URL.MANAGECARDS.EXPORT_MANAGECARD;
  try {
    const response = await fetch(basePYUrl + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: XLSX_MIME,
        authorization: cookies.get("authorization"),
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(`Export failed: ${response.status}`);
    const blob = await response.blob();
    downloadBlob(blob, "fuel-card.xlsx", XLSX_MIME);
    return { isError: false };
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const importManageCard = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const url = `${basePYUrl}${API_URL.MANAGECARDS.IMPORT_MANAGECARD}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { authorization: cookies.get("authorization") },
      body: formData,
    });
    const result = await response.json();
    if (result?.error) throw new APIError(result);
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const downloadSampleCardTemplate = async () => {
  const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  try {
    const url = `${basePYUrl}${API_URL.MANAGECARDS.DOWNLOAD_SAMPLE_TEMPLATE}`;
    const response = await fetch(url, {
      headers: { Authorization: cookies.get("authorization") },
      method: "GET",
    });
    if (!response.ok) throw new Error(`Failed to download file. Status: ${response.status}`);
    const fileBlob = await response.blob();
    downloadBlob(fileBlob, "SampleCardTemplate.xlsx", XLSX_MIME);
  } catch (error) {
    console.error("Download failed:", error);
  }
};



export const assignManageCardRecord = async (payload) => {
  try {
    let result = await postPythonApiAsyn(
      API_URL.MANAGECARDS.ASSIGN_CARD,
      payload,
      cookies.get("authorization")
    );
    if (result?.error) throw new APIError(result);
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};


export const getAssignCardCustomerDD = async (payload) => {
  const url =API_URL.MANAGECARDS.DROPDOWN;
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }
    let res = extractData(result, !payload?.filters);
    res = res?.content || [];
    res = res.map(item => ({
      label: item.company_name,
      value: item?.customer_company_id
    }));
    return { content: res };
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};